<style lang="scss" scope>
.left-menu {
  background: #ebf1f6;
  width: 217px;
  position: absolute;
  right: 0;
  left: 0;
  top: 65px;
  bottom: 45px;
  transition: all 0.4s ease;
  overflow-y: auto;

  &.on {
    left: -250px;
  }

  /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
  &::-webkit-scrollbar {
    width: 2px;
    height: 2px;
    background-color: #f5f5f5;
  }
  /*定义滚动条轨道 内阴影+圆角*/
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #f5f5f5;
  }
  /*定义滑块 内阴影+圆角*/
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
    background-color: #c1c1c1;
  }
  &-nav {
    li {
      .title {
        height: 45px;
        display: flex;
        align-items: center;
        color: #585858;
        font-size: 16px;
        position: relative;
        cursor: pointer;
        padding: 0 15px;
        .svg-icon {
          width: 24px;
          height: 24px;
          color: #f1725a;
        }
        // &::before {
        //   content: "";
        //   background: url("../../../assets/images/main-home-icon.png") no-repeat
        //     left center;
        // }
        &.active {
          background: linear-gradient(11deg, #e84d4c 0%, #f58360 100%);
          border-radius: 3px;
          color: #fff;
        }
        &-icon {
          width: 30px;
          margin-right: 10px;
          display: flex;
          overflow: hidden;
          justify-content: center;
        }
      }

      .dd {
        height: 38px;
        line-height: 38px;
        font-size: 14px;
        display: flex;
        align-items: center;
        color: #8d8d8d;
        position: relative;
        cursor: pointer;
        transition: all 0.3s ease;
        &::before {
          content: "";
          width: 9px;
          height: 9px;
          border: 1px solid #faae9c;
          border-radius: 50%;
          margin-right: 10px;
          transition: all 0.3s ease;
        }
        &::after {
          content: "";
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 20px;
          background: url("../../../assets/images/main-jt2-icon.png") no-repeat
            left center;
          width: 9px;
          height: 9px;
          opacity: 0;
          transition: all 0.3s ease;
        }
        &:hover,
        .el-menu-item.is-active,
        &.on {
          color: #e9524e;
          &::after {
            opacity: 1;
          }
          &::before {
            border: 1px solid #e84d4c;
          }
        }
      }
      &.active {
        display: block;
      }
    }
  }
}

.el-menu-item.is-active {
  .dd {
    color: #e9524e;
    &::after {
      opacity: 1;
    }
    &::before {
      border: 1px solid #e84d4c;
    }
  }
}

.el-submenu {
  .el-submenu__icon-arrow {
    right: 40px;
    // margin-top: -12px;
  }
}

.el-submenu.is-opened {
  .el-submenu__icon-arrow {
    // color: #fff;
    // background: #333;
  }
  .title {
    background: linear-gradient(11deg, #e84d4c 0%, #f58360 100%);
    border-radius: 3px;
    box-shadow: 0px 2px 9px 0px rgba(182, 26, 10, 0.33);
    span {
      color: #fff;
    }
    .svg-icon {
      color: #f7c3c1;
    }
  }
}

.el-menu {
  background:#ebf1f6 !important;
  border: 0 !important;
}

.el-submenu__title:hover {
  // background-color: transparent !important;
}
.el-submenu__title{
  color: #606266 !important;
}

.el-menu-item:hover,
.el-menu-item:focus {
  // background-color: transparent !important;
}
.el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
  -webkit-transform: rotateZ(180deg);
  transform: rotateZ(180deg);
}
</style>

<template>
  <section :class="['left-menu', { on: $store.getters.getMeunShow }]">
    <el-menu
      class="left-menu-nav"
      :unique-opened="true"
      :default-active="defaultActive"
    >
      <div v-for="(item, index) in menuList" :key="index">
        <!-- 一级菜单（没有任何子级菜单）-->
        <el-menu-item :index="item.code" v-if="!item.menus">{{item.name}}</el-menu-item>
        <!-- 一级菜单（有子级菜单）-->
        <el-submenu :index="item.code" v-else>
          <template slot="title">{{ item.name }}</template>
<!--          -->
          <!-- 遍历二级菜单容器 -->
          <div v-for="(i, indexs) in item.menus" :key="indexs">
            <!-- 判断二级菜单（没有三级菜单）-->
            <el-menu-item
                style="color: #606266"
              :index="i.code"
              v-if="!i.menus"
              @click="handleGoTo(i.view,i)"
              >{{ i.name }}</el-menu-item>
            <!-- 判断二级菜单（有三级菜单）-->
            <el-submenu :index="i.code" v-if="i.menus">
              <template slot="title">{{ i.name }}</template>
              <el-menu-item
                  style="color: #606266"
                @click="handleGoTo(j.view,j)"
                :index="j.code"
                v-for="(j, indexChlid) in i.menus"
                :key="indexChlid"
                >{{ j.name }}
              </el-menu-item>
            </el-submenu>
          </div>
        </el-submenu>
      </div>
    </el-menu>
  </section>
</template>
<script>
import bus from '../../../assets/js/eventBus'
export default {
  name: "LeftMenu",
  data() {
    return {
      menuList: [],
      menuActive: 1,
      defaultActive: "",
      Permission_loading:false,
      parMenuId:''
    };
  },

  created() {
    // this.getFrontRouter();
    //展开对应路由的菜单
    //展开对应路由的菜单
    this.defaultActive = this.$route.name;
    bus.$on('sendBybus',data=>{
      this.parMenuId = data
      this.menuData();
    })
    if(window.sessionStorage.getItem('tt_menuId')){
      this.parMenuId = window.sessionStorage.getItem('tt_menuId')
      this.menuData();
    }else {
      this.menuData();
    }
  },



  computed: {},

  methods: {
    /**
     * 获取前端所有路由
     */
    handleMenuClick(index) {
      this.menuActive = index;
    },
    /**
     * 获取菜单
     */
    async menuData() {
      let url = ''
      if(this.parMenuId){
        url = '/menus?parentId='+this.parMenuId
      }else {
        url = '/menus'
      }
      const { data: resData } = await this.$get(url, {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) {
        this.$store.commit('setJurisdiction')
        return
      };
      if(this.parMenuId){
        this.menuList = resData.data
      }else {
        this.menuList = resData.data[0].menus
      }
    },
    async getBtnTree(id,name,item) {
      //角色列表
      this.Permission_loading = false
      const { data: res } = await this.$get(`/btns?tree=true&id=${id}`);
      if (res.result != 200) return;
      window.sessionStorage.setItem('TaotanPermissionButton',res.data?JSON.stringify(res.data):JSON.stringify('[]'))
      this.Permission_loading = true
      this.$router.push({
        name,
      });
    },
    /**
     * 获取当前路由
     */
    handleGoTo(name,item) {
      window.sessionStorage.removeItem('intitle_id')
      this.getBtnTree(item.menuId,name,item)
      // if(this.Permission_loading){
      //   // setTimeout(()=>{
      //     this.Permission_loading = false
      //     this.$router.push({
      //       name,
      //     });
      //   // },500)
      // }
    },
  },
};
</script>
